import React, { useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  TextField,
  MenuItem,
} from "@mui/material";
import { Col, Row } from "react-bootstrap";
import { AiOutlineUser } from "react-icons/ai";
import { FaBusinessTime, FaNewspaper } from "react-icons/fa";

const CompleteProfile = () => {
  const [step, setStep] = useState(1);
  const [isInternshipChecked, setIsInternshipChecked] = useState(false);
  const [isJobChecked, setIsJobChecked] = useState(false);

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    if (name === "isInternshipChecked") {
      setIsInternshipChecked(checked);
      setIsJobChecked(false);
    } else {
      setIsJobChecked(checked);
      setIsInternshipChecked(false);
    }
  };
  // const [formData, setFormData] = useState({
  //   firstName: "",
  //   lastName: "",
  //   email: "",
  //   password: "",
  // });

  const nextStep = () => {
    setStep(step + 1);
  };

  const prevStep = () => {
    setStep(step - 1);
  };

  // const handleChange = (input) => (e) => {
  //   setFormData({ ...formData, [input]: e.target.value });
  // };
  return (
    <>
      <div className="step-indicator container my-4">
        <div className={`step ${step === 1 ? "active" : ""}`}>
          <h6>
            <AiOutlineUser /> &nbsp; Personal Details
          </h6>
        </div>
        <div className={`step ${step === 2 ? "active" : ""}`}>
          <h6>
            <FaBusinessTime /> &nbsp; Organization Details
          </h6>
        </div>
        <div className={`step ${step === 3 ? "active" : ""}`}>
          <h6>
            {" "}
            <FaNewspaper />
            &nbsp; Post Internship/Job
          </h6>
        </div>
      </div>
      <div className="multistep-form container p-5">
        {step === 1 && (
          <div>
            <h1>Personal details</h1>
            <Row>
              <Col>
                <div className="form-outline mb-2">
                  <TextField
                    name="First Name"
                    margin="dense"
                    type="text"
                    placeholder=" First Name "
                    variant="outlined"
                    label=" First Name "
                    // value={values.email}
                    // onChange={handleChange}
                    fullWidth
                    required
                  ></TextField>
                  {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
                </div>
              </Col>
              <Col>
                <div className="form-outline mb-2">
                  <TextField
                    name="Last Name"
                    margin="dense"
                    type="text"
                    placeholder=" Last Name "
                    variant="outlined"
                    label=" Last Name "
                    // value={values.email}
                    // onChange={handleChange}
                    fullWidth
                    required
                  ></TextField>
                  {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
                </div>
              </Col>
            </Row>
            <div className="form-outline mb-2">
              <TextField
                name="Email Id"
                margin="dense"
                type="email"
                placeholder=" Email Id "
                variant="outlined"
                label=" Email Id "
                // value={values.email}
                // onChange={handleChange}
                fullWidth
                required
              ></TextField>
              {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
            </div>
            <div className="form-outline mb-2">
              <TextField
                name="Contact Number"
                margin="dense"
                type="text"
                placeholder=" Contact Number "
                variant="outlined"
                label=" Contact Number "
                // value={values.email}
                // onChange={handleChange}
                fullWidth
                required
              ></TextField>
              {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
            </div>

            <button onClick={nextStep} className="btn btn-info">
              Next
            </button>
          </div>
        )}
        {step === 2 && (
          <div>
            <h1>Organization details</h1>
            <Row>
              <Col>
                <div className="form-outline mb-2">
                  <TextField
                    name="Organisation Name"
                    margin="dense"
                    type="text"
                    placeholder=" Organisation Name "
                    variant="outlined"
                    label=" Organisation Name "
                    // value={values.email}
                    // onChange={handleChange}
                    fullWidth
                    required
                  ></TextField>
                  {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
                </div>
              </Col>
              <Col>
                <div className="form-outline mb-2">
                  <TextField
                    name="Organisation Description"
                    margin="dense"
                    type="text"
                    placeholder=" Organisation Description "
                    variant="outlined"
                    label=" Organisation Description "
                    // value={values.email}
                    // onChange={handleChange}
                    fullWidth
                    required
                  ></TextField>
                  {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
                </div>
              </Col>
            </Row>
            <div className="form-outline mb-2">
              <TextField
                name="Organisation City"
                margin="dense"
                type="email"
                placeholder=" Organisation City "
                variant="outlined"
                label=" Organisation City "
                // value={values.email}
                // onChange={handleChange}
                fullWidth
                required
              ></TextField>
              {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
            </div>
            <div className="form-outline mb-2">
              <TextField
                name="Industry"
                margin="dense"
                type="text"
                placeholder=" Industry "
                variant="outlined"
                label=" Industry "
                // value={values.email}
                // onChange={handleChange}
                fullWidth
                required
              ></TextField>
              {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
            </div>

            <div className="mb-3">
              <label htmlFor="">Organisation Logo</label>
              <input type="file" name="" className="form-control" id="" />
            </div>

            <div className="mb-2">
              <FormControl fullWidth required className="mt-2">
                <InputLabel id="demo-simple-select-label">
                  No. Of. Employee
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Year"
                  variant="outlined"
                  name="mode"
                  // value={values.division}
                  required
                >
                  <MenuItem value="1">0-50</MenuItem>
                  <MenuItem value="2">51-200</MenuItem>
                  <MenuItem value="3">200-500</MenuItem>
                  <MenuItem value="4">501-1000</MenuItem>
                </Select>
                {/* {errors.division ? (
                            <p className="text-danger mb-0">
                              {errors.division}
                            </p>
                          ) : null} */}
              </FormControl>
            </div>

            <button onClick={prevStep} className="btn btn-info">
              Previous
            </button>
            <button onClick={nextStep} className="btn btn-info ms-2">
              Next
            </button>
          </div>
        )}
        {step === 3 && (
          <div>
            <div>
              <h6>Opportunity type</h6>
              <p className="p-2 border">
                <span>
                  <input
                    type="checkbox"
                    name="isInternshipChecked"
                    checked={isInternshipChecked}
                    onChange={handleCheckboxChange}
                  />{" "}
                  Internship
                </span>{" "}
                &nbsp;
                <span>
                  <input
                    type="checkbox"
                    name="isJobChecked"
                    checked={isJobChecked}
                    onChange={handleCheckboxChange}
                  />{" "}
                  Job
                </span>
              </p>
            </div>

            {/* internship */}

            {isInternshipChecked && (
              <div>
                <div>
                  <Row>
                    <h6></h6>
                    <Col>
                      <div className="form-outline mb-2">
                        <TextField
                          name="position"
                          margin="dense"
                          type="text"
                          placeholder="Internship Position"
                          variant="outlined"
                          label="Internship Position"
                          // value={values.email}
                          // onChange={handleChange}
                          fullWidth
                          required
                        ></TextField>
                        {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
                      </div>
                      <div className="form-outline mb-2">
                        <TextField
                          name="description"
                          margin="dense"
                          type="text"
                          placeholder="Description"
                          variant="outlined"
                          label="Internship Description"
                          // value={values.email}
                          // onChange={handleChange}
                          fullWidth
                          required
                        ></TextField>
                        {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
                      </div>
                      <div className="form-outline mb-2">
                        <TextField
                          name="companyname"
                          margin="dense"
                          type="text"
                          placeholder="Company Name"
                          variant="outlined"
                          label="Company Name"
                          // value={values.email}
                          // onChange={handleChange}
                          fullWidth
                          required
                        ></TextField>
                        {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
                      </div>
                      <div className="form-outline mb-2">
                        <label htmlFor="">Company Logo</label>
                        <input
                          type="file"
                          name=""
                          className="form-control"
                          id=""
                        />
                      </div>
                      <div className="form-outline mb-2">
                        <TextField
                          name="period"
                          margin="dense"
                          type="text"
                          placeholder="Internship Period"
                          variant="outlined"
                          label="Internship Period"
                          // value={values.email}
                          // onChange={handleChange}
                          fullWidth
                          required
                        ></TextField>
                        {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
                      </div>
                    </Col>
                    <Col>
                      <div className="form-outline mb-2">
                        <TextField
                          name="lastdate"
                          margin="dense"
                          type="text"
                          placeholder="Last Date"
                          variant="outlined"
                          label="Last Date"
                          // value={values.email}
                          // onChange={handleChange}
                          fullWidth
                          required
                        ></TextField>
                        {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
                      </div>
                      <div className="mb-2">
                        <FormControl fullWidth required className="mt-2">
                          <InputLabel id="demo-simple-select-label">
                            Internship Mode
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Year"
                            variant="outlined"
                            name="mode"
                            // value={values.division}
                            required
                          >
                            <MenuItem value="Online">Online</MenuItem>
                            <MenuItem value="offline">Offline</MenuItem>
                          </Select>
                          {/* {errors.division ? (
                            <p className="text-danger mb-0">
                              {errors.division}
                            </p>
                          ) : null} */}
                        </FormControl>
                      </div>
                      <div className="mb-2">
                        <FormControl fullWidth required className="mt-2">
                          <InputLabel id="demo-simple-select-label">
                            Internship Type
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Year"
                            variant="outlined"
                            name="mode"
                            // value={values.division}
                            required
                          >
                            <MenuItem value="Online">Part Time</MenuItem>
                            <MenuItem value="offline">Full Time</MenuItem>
                          </Select>
                          {/* {errors.division ? (
                            <p className="text-danger mb-0">
                              {errors.division}
                            </p>
                          ) : null} */}
                        </FormControl>
                      </div>
                      <div className="form-outline mb-2">
                        <TextField
                          name="Number Of Opening"
                          margin="dense"
                          type="text"
                          placeholder="Number Of Opening"
                          variant="outlined"
                          label="Number Of Opening"
                          // value={values.email}
                          // onChange={handleChange}
                          fullWidth
                          required
                        ></TextField>
                        {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
                      </div>
                      <div className="form-outline mb-2">
                        <TextField
                          name="location"
                          margin="dense"
                          type="text"
                          placeholder="location"
                          variant="outlined"
                          label="Location"
                          // value={values.email}
                          // onChange={handleChange}
                          fullWidth
                          required
                        ></TextField>
                        {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <div>
                        <FormControl fullWidth required className="mt-2">
                          <InputLabel id="demo-simple-select-label">
                            Internship Duration
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Year"
                            variant="outlined"
                            name="mode"
                            // value={values.division}
                            required
                          >
                            <MenuItem value="1">1</MenuItem>
                            <MenuItem value="2">2</MenuItem>
                            <MenuItem value="2">3</MenuItem>
                            <MenuItem value="2">4</MenuItem>
                            <MenuItem value="2">5</MenuItem>
                          </Select>
                          {/* {errors.division ? (
                            <p className="text-danger mb-0">
                              {errors.division}
                            </p>
                          ) : null} */}
                        </FormControl>
                      </div>
                    </Col>
                    <Col>
                      <div className="form-outline mb-2">
                        <TextField
                          name="formlink"
                          margin="dense"
                          type="text"
                          placeholder="Application Form Link"
                          variant="outlined"
                          label="Application Form Link"
                          // value={values.email}
                          // onChange={handleChange}
                          fullWidth
                          required
                        ></TextField>
                        {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            )}

            {isJobChecked && (
              <div>
                <Row>
                  <Col>
                    <div className="form-outline mb-2">
                      <TextField
                        name="jobtitle"
                        margin="dense"
                        type="text"
                        placeholder="Job Title"
                        variant="outlined"
                        label="Job Title"
                        // value={values.email}
                        // onChange={handleChange}
                        fullWidth
                        required
                      ></TextField>
                      {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
                    </div>
                  </Col>
                  <Col>
                    <div className="form-outline mb-2">
                      <TextField
                        name="skills"
                        margin="dense"
                        type="text"
                        placeholder="Skills Required"
                        variant="outlined"
                        label="Skills Required"
                        // value={values.email}
                        // onChange={handleChange}
                        fullWidth
                        required
                      ></TextField>
                      {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p className="p-2 ">
                      <label htmlFor="">Job Type</label>
                      <br />
                      <span>
                        <input type="checkbox" /> &nbsp; In Office / Hybrid
                      </span>
                      &nbsp;
                      <span>
                        <input type="checkbox" /> &nbsp; Remote
                      </span>
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="form-outline mb-2">
                      <TextField
                        name="noofopening"
                        margin="dense"
                        type="text"
                        placeholder="Number Of Opening"
                        variant="outlined"
                        label="Number Of Opening"
                        // value={values.email}
                        // onChange={handleChange}
                        fullWidth
                        required
                      ></TextField>
                      {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
                    </div>
                  </Col>
                  <Col>
                    <div className="form-outline mb-2">
                      <TextField
                        name="jobdescription"
                        margin="dense"
                        type="text"
                        placeholder="Job Description"
                        variant="outlined"
                        label="Job Description"
                        // value={values.email}
                        // onChange={handleChange}
                        fullWidth
                        required
                      ></TextField>
                      {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
                    </div>
                  </Col>
                </Row>
              </div>
            )}

            <button onClick={prevStep} className="btn btn-info">
              Previous
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default CompleteProfile;
